import { getConfig } from '@cian/config/browser';
export function getFilters() {
    const filterStrings = getConfig().get('logger.browser.errorFilter');
    return (filterStrings || []).map(filterString => new RegExp(filterString));
}
//# sourceMappingURL=getFilters.js.map